{
  "VALIDATION_FAILED": "The submitted data is not valid",
  "USERNAME_TAKEN": "This username is already in use",
  "TEMPLATE_EXISTS": "A template with this key and language already exists",
  "SYSTEM_EXISTS": "A system with this code already exists",
  "MESSAGE_NOT_RETRYABLE": "This message cannot be resent in its current status",
  "TEMPLATE_NOT_FOUND": "The template is missing or inactive",
  "NO_PLATFORM_ACCESS": "You do not have access to this platform",
  "UA_UNAVAILABLE": "Unified Access could not be reached. Try again shortly.",
  "INTEGRATION_UNAUTHORIZED": "Invalid integration credentials",
  "UNAUTHENTICATED": "You need to sign in",
  "INVALID_CREDENTIALS": "Invalid email or password",
  "FORBIDDEN": "You do not have permission for this action",
  "NOT_FOUND": "The requested item was not found",
  "CONFLICT": "Conflicting data. Reload the current data.",
  "UNIQUE_VIOLATION": "This value is already in use",
  "FOREIGN_KEY_VIOLATION": "This item is referenced elsewhere and cannot be deleted",
  "RATE_LIMITED": "Too many attempts. Try again shortly.",
  "IDEMPOTENCY_KEY_REUSED": "This request number was already used for another operation",
  "REQUEST_IN_PROGRESS": "This request is still being processed",
  "PAYLOAD_TOO_LARGE": "The submitted data exceeds the maximum size",
  "UNPROCESSABLE": "The request could not be processed. Check the submitted data.",
  "INTERNAL_ERROR": "The operation could not be completed. Try again or contact your administrator.",
  "SERVICE_UNAVAILABLE": "The service is unavailable right now. Try again shortly.",
  "network": "Could not reach the server. Check your connection and try again.",
  "timeout": "We could not confirm this finished. Check the current state before trying again.",
  "IDEMPOTENCY_CONFLICT": "The same request key was already used for a different request",
  "VERIFICATION_SEND_FAILED": "The verification code could not be sent by WhatsApp",
  "SEND_IN_PROGRESS": "Sending the code...",
  "SEND_OUTCOME_UNKNOWN": "The verification code could not be sent by WhatsApp"
}
